// The engine's ids (pid) for the card gateways it lists under payType
// "GATEWAY" in content/trans/paymodes. The same ids the iPhone and Android
// apps use. The payment page chooses by these ids, never by the name shown,
// which the CMS can change and which differs between English and Arabic.
export const KNET_PID = "401";
export const CREDIT_CARD_PID = "402";
export const MASTERCARD_PID = "404";

// True when a pid (a string or a number from the engine) is the wanted one.
// An empty or missing pid is never a match.
export const isPid = (pid, wanted) =>
  pid !== null && pid !== undefined && String(pid) !== "" && String(pid) === String(wanted);

// Which payment the Proceed button starts for the gateway chosen:
// "knet", "card" (Cybersource with 3-D Secure) or "mastercard"; null for
// anything else (wallet and gift card are chosen apart from the gateways).
export const gatewayFor = (pid) => {
  if (isPid(pid, KNET_PID)) return "knet";
  if (isPid(pid, CREDIT_CARD_PID)) return "card";
  if (isPid(pid, MASTERCARD_PID)) return "mastercard";
  return null;
};

// Whether a gateway can be chosen. A bank offer is tied to the card it was
// applied with (knetallowed is then false), so only the credit card stays.
export const isGatewaySelectable = (pid, knetallowed) =>
  isPid(pid, CREDIT_CARD_PID) || ((isPid(pid, KNET_PID) || isPid(pid, MASTERCARD_PID)) && knetallowed === true);

// KNET and Mastercard open the bank's own page, so Proceed is ready at once;
// the credit card waits for the card details to be typed.
export const proceedsAtOnce = (pid) => isPid(pid, KNET_PID) || isPid(pid, MASTERCARD_PID);
